/* Velunna — product.js: barra fija de "Añadir al carrito" en la ficha (sobre todo en móvil) */
(() => {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;
  const sticky = section.querySelector('[data-sticky-atc]');
  const mainBuy = section.querySelector('[data-main-buy]');
  if (!sticky || !mainBuy || !('IntersectionObserver' in window)) return;
  sticky.hidden = false;
  const footer = document.querySelector('.footer');
  let buyVisible = true; let footerVisible = false;
  const update = () => sticky.classList.toggle('is-visible', !buyVisible && !footerVisible);
  new IntersectionObserver(([e]) => { buyVisible = e.isIntersecting || e.boundingClientRect.top > 0; update(); }).observe(mainBuy);
  if (footer) new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; update(); }).observe(footer);
  sticky.querySelector('[data-sticky-add]').addEventListener('click', () => {
    const form = mainBuy.querySelector('form');
    if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
  });
})();
